<template>
  <div
    ref="card"
    :class="$style.card"
    @click="navigateToCar"
  >
    <div :class="$style.header">
      <div :class="$style.brandLogo">
        <img
          :src="brandLogo"
          :alt="brandName"
        >
      </div>
      <router-link
        :to="{ name: 'Products/Car', params: { carId } }"
        :class="$style.title"
      >
        {{ model }}
      </router-link>
    </div>
    <div :class="[$style.infoRow, $style.isTop]">
      <div :class="$style.infoRowSection">
        <span :class="$style.spec">
          <JigsawSvg />
          <span>
            {{ projectCode }}
          </span>
        </span>
        <span :class="$style.spec">
          <PowertrainSvg />
          <span>
            {{ powerTrain }}
          </span>
        </span>
      </div>
      <div :class="$style.infoRowSection">
        <BaseLabel
          :class="$style.label"
          color="violet"
        >
          {{ body }}
        </BaseLabel>
        <BaseLabel
          :class="$style.label"
          color="lime"
        >
          Gen {{ generation }}
        </BaseLabel>
        <BaseLabel
          :class="$style.label"
          color="barley"
        >
          Phase {{ phase }}
        </BaseLabel>
        <BaseLabel
          :class="$style.label"
          color="aqua"
        >
          {{ country.region }}
          <img
            :src="`/images/icons/flags/${country.code.toLowerCase()}.png`"
            :alt="supplierCountry"
            :class="$style.flag"
          >
        </BaseLabel>
      </div>
    </div>
    <div :class="$style.images">
      <div
        :class="$style.image"
        :style="{ backgroundImage: `url('${frontImage || '/images/default-car-front.jpg'}')` }"
      />
      <div
        :class="$style.image"
        :style="{ backgroundImage: `url('${backImage || '/images/default-car-back.jpg'}')` }"
      />
    </div>
    <div :class="[$style.infoRow, $style.isBottom]">
      <div :class="$style.infoRowSection">
        <span :class="$style.spec">
          <DateStartSvg />
          <span>
            {{ format(new Date(sop), 'MMM y') }} – {{ format(new Date(eop), 'MMM y') }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import BaseLabel from '@/components/base/Label';
import JigsawSvg from '@/assets/images/icons/table-jigsaw.svg?inline';
import PowertrainSvg from '@/assets/images/icons/table-powertrain.svg?inline';
import DateStartSvg from '@/assets/images/icons/table-date-start.svg?inline';

export default {
  components: {
    BaseLabel,
    JigsawSvg,
    PowertrainSvg,
    DateStartSvg,
  },
  props: {
    brandName: {
      type: String,
      default: null,
    },
    brandLogo: {
      type: String,
      default: null,
    },
    model: {
      type: String,
      default: null,
    },
    carId: {
      type: Number,
      default: null,
    },
    projectCode: {
      type: String,
      default: null,
    },
    powerTrain: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    generation: {
      type: Number,
      default: null,
    },
    phase: {
      type: Number,
      default: null,
    },
    frontImage: {
      type: String,
      default: null,
    },
    backImage: {
      type: String,
      default: null,
    },
    sop: {
      type: String,
      default: null,
    },
    eop: {
      type: String,
      default: null,
    },
    country: {
      type: Object,
      default: null,
    },
  },
  methods: {
    format,
    navigateToCar() {
      const selection = window.getSelection();
      const isTextSelected = selection.toString() !== '';

      if (
        isTextSelected
        && (
          this.$refs.card.contains(selection.anchorNode)
          || this.$refs.card.contains(selection.focusNode)
        )
      ) {
        return;
      }

      this.$router.push({ name: 'Products/Car', params: { carId: this.carId } });
    },
  },
};
</script>

<style lang="scss" module>
.card {
  padding: 25px 20px;
  cursor: pointer;
}

.header {
  display: flex;
  align-items: center;
}

.brandLogo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.title {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 500;
  color: $title;
  text-decoration: none;
}

.carId {
  margin-left: auto;
  font-size: 13px;
  color: $text;
}

.infoRow {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.isTop {
    margin-top: 20px;
  }

  &.isBottom {
    margin-top: 10px;
  }
}

.flag {
  margin-bottom: -1px;
  margin-left: 3px;
}

.infoRowSection {
  display: flex;
  align-items: center;

  .label {

    &:not(:first-child) {
      margin-left: 5px;
    }
  }
}

.spec {
  display: inline-flex;
  align-items: center;
  font-size: 13px;

  &:not(:first-child) {
    margin-left: 15px;
  }

  svg {
    margin-top: -3px;
    margin-right: 5px;
  }
}

.images {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(50% - 4px);
  padding-top: 40.625%;
  overflow: hidden;
  background-color: $background-light;
  background-position: center;
  background-size: cover;
  border-radius: 5px;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
  }
}
</style>
